import { makeStyles } from "@material-ui/core";

const useSelectStyles = makeStyles({
  select: {
    width: "100%",
    textAlign: "start",
    borderRadius: "6px",
    height: "43px",
    alignItems: "center",
  },
  label: {
    height: "10px",
    fontFamily: "Dubai",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    color: "rgba(0, 0, 0, 0.5)",
  },
});

export const indicatorStyles = (base: any) => ({
  ...base,
  backgroundColor: "rgb(0,100,216)",
  borderRadius: "6px",
  width: "34px",
  height: "34px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginInlineEnd: "5px",
  alignSelf: "center",
});

export default useSelectStyles;
